
import { Box, Button, Card, Typography } from "@mui/material";
import ListaVazia from "../../../../utils/listaVazia";
// import ObservacoesFeitas from "../../dlif/observacoesFeitas";
import { useState } from "react";
import api from "../../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import LoadingShort from "../../../../load/loadingShort";

export default function NavLateral({ notificacao, setUpdate }) {
  const [load, setLoad] = useState(false);
  const user = useSelector((state) => state.account.user);
  // const navigate = useNavigate()
  const dispatch = useDispatch()


  async function changeStatusnotificacao() {
    setLoad(true);
    // setErrorMessage("");
    // setMessageSuccess("");

    await api.patch("/farmaco-vigilancia/change-status", {
      status: "Analisado",
      farmacoVigilanciaId: notificacao._id,
      userId: user._id,
      // observacao
    })
      .then((response) => {
        console.log(response)
        setLoad(false);
        // setMessageSuccess(response.data.msg);
        setUpdate(response.data);

        dispatch({
          type: 'alert',
          payload: { alert: `Notificação analisada` },
        });

        window.setTimeout(() => {
          // navigate('/admin/notificacao/entradas')
        }, 5000);
      })
      .catch((error) => {
        console.log(error)
        // setErrorMessage(error.response.data.message);
        setLoad(false);
      });
  }

  return (
    <>
      <Card style={{ padding: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/expediente/entrada.svg" alt="img" width={'100%'} />
        </div>

        <Typography m align="center">
          Estado da Notificação
          <br />
          <b>{notificacao.status} </b>
        </Typography>

        <Box>
          <br />
          {notificacao?.status !== "Analisado" ? (
            <Button
              fullWidth
              disabled={load}
              size="small"
              color="success"
              variant="outlined"
              onClick={changeStatusnotificacao}
            >
              {load ? <LoadingShort /> : "Analisado"}
            </Button>
          ) : (
            <ListaVazia text={"Processo já análisado!"} />
          )}
        </Box>
      </Card>
      <br />

      {/* {observacoesFeitas?.length > 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )} */}
    </>
  );
}
